// extracted by mini-css-extract-plugin
export default {"values-section":"TeamsValuesSection_values-section__Wm4o2","values-center-content":"TeamsValuesSection_values-center-content__PFx8O"};